import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, withRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import config from "./config";
import Amplify from "aws-amplify";

// Simplified Amplify configuration - removed Auth since bilingual app doesn't use it
Amplify.configure({
  API: {
    endpoints: [
      {
        name: "dev-aya",
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
    ],
  },
});

const AppWithRouter = withRouter(App);

ReactDOM.render(
  <Router>
    <AppWithRouter />
  </Router>,
  document.getElementById('root')
);

// UPDATED: Enhanced service worker registration with proper callbacks
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('Service Worker registered successfully:', registration);
    console.log('App is now available offline!');
  },
  onUpdate: (registration) => {
    console.log('Service Worker updated:', registration);
    // The update notification will be handled by the serviceWorkerRegistration.js
  }
});

// ADDED: Debug logging for offline/online events (helpful for development)
if (process.env.NODE_ENV === 'development') {
  console.log('App started in development mode');
  
  // Log when the app goes offline/online
  window.addEventListener('online', () => {
    console.log('App came online - attempting to sync fresh content');
    // You could trigger a content refresh here if needed
    window.dispatchEvent(new CustomEvent('app-online'));
  });
  
  window.addEventListener('offline', () => {
    console.log('App went offline - using cached content');
    window.dispatchEvent(new CustomEvent('app-offline'));
  });
}

// ADDED: Listen for service worker updates and handle them gracefully
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.ready.then((registration) => {
      console.log('Service Worker is ready');
      
      // Check for updates every 5 minutes when the app is active
      setInterval(() => {
        if (document.visibilityState === 'visible') {
          registration.update();
        }
      }, 5 * 60 * 1000); // 5 minutes
    });

    // Listen for messages from service worker
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data.type === 'CONTENTFUL_DATA_UPDATED') {
        console.log('Contentful data updated by service worker');
        // Dispatch custom event to notify components
        window.dispatchEvent(new CustomEvent('contentful-data-updated'));
      }
    });
  });
}

reportWebVitals();